import * as React from 'react';
import {FieldData} from 'src/app/model/lighthouse/Common';
import FieldRenderer from 'src/app/component/lighthouse/review/FieldRenderer';

export interface DataPointsSectionProps {
    /** Array of data point fields returned by the backend. */
    fields: FieldData[];
}

/**
 * Renders the "Data Points" section of the Lighthouse Review page.
 * Data points are always read-only — they provide contextual information
 * (e.g. risk scores, account age) that auditors observe but cannot edit.
 */
const DataPointsSection: React.FC<DataPointsSectionProps> = ({fields}) => {
    const hasFields = Array.isArray(fields) && fields.length > 0;

    return (
        <div className="lighthouse-section" data-testid="data-points-section">
            <div className="lighthouse-section-title">Data Points</div>
            {hasFields ? (
                <div className="lighthouse-section-content">
                    {fields.map(field => (
                        <FieldRenderer
                            key={field.label}
                            field={field}
                            readOnly={true}
                        />
                    ))}
                </div>
            ) : (
                <div className="lighthouse-section-empty" data-testid="data-points-empty">
                    No data points available.
                </div>
            )}
        </div>
    );
};

export default DataPointsSection;
